import React from 'react'
import {
  StyledImageContainer,
  StyledPlaceholder,
} from './CardImage.styled'
import colorsMatcher from '../../interfaces/ColorsMatcher'
import MediaTypeEnum from '../../enums/MediaType'
import { DEFAULT_ALT_IMAGE } from '../../constants/DefaultAlts'
import NormalizeMedia from '../../utils/NormalizeMedia'

const CardImage = (props) => {
  const { image, thumbnail, backgroundColor } = props

  if (!image && !thumbnail) {
    return <StyledPlaceholder color={colorsMatcher[backgroundColor]} />
  }
  const media = thumbnail ? thumbnail : image
  return <StyledImageContainer>{NormalizeMedia(media)}</StyledImageContainer>
}

CardImage.propTypes = {}

export default CardImage
